import React, { Component } from 'react'
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import LoadingButton from '../../../../../facturotopia/LoadingButton';

class CatalogoClienteItemActions extends Component {

  state = {
    busy: false,
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnDownloadActionClick = async (original) => {
    //implementar
  }

  handleOnAction = (action) => {
  }

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { busy } = this.state;

    return (
      <>
        <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
          { selectedRowKeys.length === 1 && (
            <LoadingButton
              variant="secondary"
              loading={ busy }
              onClick={ this.handleOnDownloadActionClick.bind(this, undefined) }
            >
              { busy === true ? 'Descargando' : 'Action' }
            </LoadingButton>
          ) }

          <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />
        </Dropdown>
      </>

    )
  }
}

export default CatalogoClienteItemActions;